import moment from 'moment'

export const parseDate = (date, strict = true) =>
  moment(date, 'DD.MM.YYYY', strict)
export const parseDateTime = (date, strict = true) =>
  moment(date, 'DD.MM.YYYY HH:mm:ss', strict)
export const formatDate = (date) => (date || moment()).format('DD.MM.YYYY')
export const formatTime = (date) => (date || moment()).format('HH:mm:ss')
